/** @jsx builderX.jsx */

import { builderX, Sprite, Image, Button } from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite name='balanceBar_portrait'>
        <Button position={[251, 2714]} hitArea={{ width: 325, x: 0, y: 0, type: 'rectangle', height: 291 }} name='plusButton'>
            <Sprite>
                <Image src='plus_button_normal' />
            </Sprite>
            <Sprite>
                <Image src='plus_button_normal' />
            </Sprite>
            <Sprite>
                <Image src='plus_button_pressed' />
            </Sprite>
            <Sprite>
                <Image src='plus_button_disabled' />
            </Sprite>
        </Button>
        <Button position={[251, 3005]} hitArea={{ width: 325, x: 0, y: 0, type: 'rectangle', height: 291 }} name='minusButton'>
            <Sprite>
                <Image src='minus_button_normal' />
            </Sprite>
            <Sprite>
                <Image src='minus_button_normal' />
            </Sprite>
            <Sprite>
                <Image src='minus_button_pressed' />
            </Sprite>
            <Sprite>
                <Image src='minus_button_disabled' />
            </Sprite>
        </Button>
    </Sprite>
);
